import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/+16479601930?text=Hello%2C%20I%20need%20help%20with%20my%20tax%20consultation."
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-10 right-0 md:right-10 bg-green-600 text-white px-4 py-3 rounded-full w-52 shadow-md hover:bg-green-500 transition-colors duration-300 flex items-center space-x-3"
      style={{ zIndex: 1000 }}
    >
      <FontAwesomeIcon icon={faWhatsapp} className="text-white text-2xl" />
      <span>Chat on WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;